var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"21","height":"18","viewBox":"0 0 21 18","fill":"none"}},[_c('rect',{attrs:{"x":"21","width":"18","height":"21","transform":"rotate(90 21 0)","fill":"#999999"}}),_vm._v("\n  />\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }